import './BatchActivitiesCompleteExecutor.scss';
import React from 'react';
import { useForm } from 'react-hook-form';
import { DocumentExecutionService } from '@services/actions/DocumentExecutionService';
import ModalContainer, { IModalContainerProps } from '@molecules/ModalContainer/ModalContainer';
import TextareaControl from '@srm/ui/controls/TextareaControl';
import { stringifyError } from '@srm/core/errors';
import { useActionSubmit } from '@organisms/actions/useActionSubmit';
import { useUnsavedFormInput } from '@srm/ui/hooks/useUnsavedFormInput';
import { IBatchActivitiesCompleteExecutorProps } from './IBatchActivitiesCompleteExecutorProps';

interface IBatchActivitiesCompleteFormData {
    comment?: string;
}

export const BatchActivitiesCompleteExecutorModal: React.FC<IBatchActivitiesCompleteExecutorProps> = (
    props: IBatchActivitiesCompleteExecutorProps,
) => {
    const formMethods = useForm<IBatchActivitiesCompleteFormData>({ mode: 'onBlur' });
    const hasUnsavedInput = useUnsavedFormInput(formMethods, { textFields: ['comment'] });

    const { errorText, isBusy, isSubmitting, okClick, cancelClick } = useActionSubmit({
        completeHandler: props.completeHandler,
        initialBusy: false,
        resetErrorOnSubmit: true,
        mapError: stringifyError,
        submit: (form: IBatchActivitiesCompleteFormData) =>
            new DocumentExecutionService(props.docId).batchActivitiesComplete(props.actionKey, form.comment),
    });

    const modalContainerProps: IModalContainerProps = {
        header: props.title,
        size: props.modalSize,
        showOkButton: true,
        showCancelButton: true,
        okButtonText: props.okButtonText,
        cancelButtonText: props.cancelButtonText,
        loading: isBusy,
        closeDisabled: isSubmitting,
        hasUnsavedInput,
        errorText: errorText,
        formMethods: formMethods,
        onSubmit: okClick,
        onCancel: cancelClick,
    };

    return (
        <ModalContainer {...modalContainerProps}>
            <TextareaControl name="comment" label="Комментарий" rows={6} control={formMethods.control} />
        </ModalContainer>
    );
};
